'use client';

import { useRouter } from 'next/navigation';
import { Container, SectionLabel, SectionRule } from '../ReferenceChrome';

const POSTS = [
  {
    category: 'SEO Strategy',
    date: 'Jun 10, 2025',
    readTime: '6 min read',
    title: 'How Competitor Keyword Gap Analysis Doubled Our Organic Traffic',
  },
  {
    category: 'Content Automation',
    date: 'Jun 3, 2025',
    readTime: '8 min read',
    title: '5 Proven Workflows That Close Keyword Gaps 10× Faster',
  },
  {
    category: 'Case Study',
    date: 'May 28, 2025',
    readTime: '5 min read',
    title: 'The Ultimate Guide to AI-Powered SEO Content at Scale',
  },
];

export function BlogCardsRef({ hideHeader }: { hideHeader?: boolean } = {}) {
  const router = useRouter();

  return (
    <section className="pb-16 sm:pb-24">
      <SectionRule />
      <Container className={`pt-16 sm:pt-24 ${hideHeader ? 'hidden' : ''}`}>
        {/* Centered header */}
        <div className="mb-10 text-center">
          <SectionLabel>Blog</SectionLabel>
          <h2 className="mt-3 text-3xl font-normal tracking-tight text-gray-900 sm:text-4xl">
            Insights, Tips &amp; Trends
          </h2>
        </div>
      </Container>

      {/*
        Bordered grid — edges align with the two vertical rail lines.
        ─────────── top border ───────────
        │ card1 │ card2 │ card3 │
        ─────────── bottom border ────────
      */}
      <div
        className="rail-inset-x mt-10 border-t border-b border-gray-200"
      >
        <div className="grid grid-cols-1 divide-y divide-gray-200 sm:grid-cols-3 sm:divide-x sm:divide-y-0">
          {POSTS.map((post) => (
            <article
              key={post.title}
              className="group flex cursor-pointer flex-col px-8 py-8 sm:px-10"
              onClick={() => router.push('/blog')}
            >
              <div
                className="w-full overflow-hidden rounded-lg bg-gray-100"
                style={{ aspectRatio: '16/10' }}
              />
              <div className="mt-4 flex flex-1 flex-col">
                <span className="inline-flex w-fit rounded-sm bg-gray-100 px-2 py-0.5 text-[11px] font-medium text-gray-600">
                  {post.category}
                </span>
                <h3 className="mt-2.5 text-base font-bold leading-snug text-gray-900 transition-colors group-hover:text-[#129990]">
                  {post.title}
                </h3>
                <p className="mt-auto pt-3 text-[11px] text-gray-400">
                  {post.date} · {post.readTime}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>

      {/* "View all posts" — centered below grid, visible on all sizes */}
      <div className="mt-8 flex justify-center">
        <button
          type="button"
          onClick={() => router.push('/blog')}
          className="inline-flex cursor-pointer items-center justify-center rounded-md border border-gray-200 bg-white px-4 py-2 text-sm font-medium text-gray-700 shadow-sm transition-all duration-75 hover:border-gray-300 hover:shadow-md active:translate-y-[2px]"
        >
          Load More
        </button>
      </div>
    </section>
  );
}
